module.exports = __webpack_public_path__ + "static/media/set_cookie.501f9ee2.png";